import HRLayout from "../hr/HRLayout";
import Giris from "../components/Giris";

export default function GirisPage() {
  return (
    <HRLayout>
      <Giris />
    </HRLayout>
  );
}
